<template>
  <div class="dossier-page">
    <Breadcrumbs v-if="isCompanyInfoPage"
                 :links="breadCrumbsLinks"/>
    <div class="dossier-page__content  container">
      <div class="dossier-page__inner  container-inner">
        <SearchDossier :companySlugRouteKey="companySlugRouteKey"
                       class="dossier-page__search"/>
        <InformationDossier class="dossier-page__info"
                            :pending="pending"
                            :companyData="companyData"
                            :employerProfile="employerProfile"
                            :error="error"
                            :errorMessage="errorMessage"/>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <CompanyVacanciesList v-if="!pending && employerProfile && vacancies && vacancies.length"
                            :employerProfile="employerProfile"
                            :vacancies="vacancies"/>
    </transition>
  </div>
</template>

<script>
  // import '../assets/less/style.robot.less'
  import {CancelToken, isCancel} from 'axios'
  import {http} from '@/axios'
  import globalMetaMixin from '@/mixins/globalMetaMixin'
  import {setMetaRobots, deleteMetaRobots} from '@/helpers/metaRobots'
  import Breadcrumbs from '@/components/Breadcrumbs'
  import SearchDossier from '@/components/dossier/SearchDossier'
  import InformationDossier from '@/components/dossier/InformationDossier'
  import CompanyVacanciesList from '@/components/dossier/CompanyVacanciesList'

  let cancel

  export default {
    name: 'CompanyDossierPage',
    mixins: [globalMetaMixin],
    components: {
      CompanyVacanciesList,
      InformationDossier,
      SearchDossier,
      Breadcrumbs,
    },
    props: {
      companySlugRouteKey: {
        type: String,
        default: 'companySlug'
      }
    },
    data() {
      return {
        pending: false,
        companyData: null,
        employerProfile: null,
        vacancies: null,

        error: null,
        errorMessage: null,
        loadedSlug: null
      }
    },
    computed: {
      isCompanyInfoPage() {
        return this.isRouteNameMixin('company-info')
      },
      companySlug() {
        return this.$route.params[this.companySlugRouteKey]
      },
      countryId() {
        return this.$route.query.country_id
      },
      breadCrumbsLinks() {
        const links = [{
          name: this.$tDossier('Company info')
        }]

        return links
      }
    },
    methods: {
      load() {
        this.companyData = null
        this.employerProfile = null
        this.vacancies = null

        this.error = null
        this.errorMessage = null

        if (!this.companySlug) return

        if (cancel) {
          cancel()
          cancel = null
        }

        this.pending = true

        const params = {
          country_id: this.countryId
        }

        return http.get(`/api/company/${this.companySlug}`, {
          params,
          cancelToken: new CancelToken(function executor(c) {
            cancel = c
          })
        }).then(({data}) => {
          const status = data.data.company_data.status

          if (status === 'ERROR_PARSING_DATA') {
            this.error = this.$tDossier('Sorry, there was an error!')
            this.errorMessage = this.$tDossier('Please try again later')

            this.pending = false
            return
          }

          if (status !== 'SUCCESS') {
            setTimeout(this.load)
            return
          }

          this.companyData = data.data.company_data
          this.employerProfile = data.data.employer_profile
          this.vacancies = data.data.vacancies

          if (this.employerProfile.slug !== this.companySlug) {
            this.loadedSlug = this.employerProfile.slug

            this.$router.replace({
              params: {
                companySlug: this.employerProfile.slug
              }
            })
          }

          this.pending = false
        }).catch((error) => {
          if (isCancel(error)) {
            return error
          }

          if (this.$get(error, 'request.status') === 500) {
            setTimeout(this.load)
            return error
          }

          this.error = error.response && error.response.data && error.response.data.message || error.message
          this.pending = false
        })
      },
      setMetaRobots() {
        if (this.companySlug) {
          setMetaRobots('noindex, follow', 404)
        } else {
          deleteMetaRobots()
        }
      }
    },
    created() {
      this.load()
      this.setMetaRobots()

      this.setMetaTitleMixin(this.$tMeta('company-dossier-meta-title'))
      this.setMetaDescriptionMixin(this.$tMeta('company-dossier-meta-description'))
      this.setOpenGraph({
        title: this.$tMeta('company-dossier-meta-title'),
        description: this.$tMeta('company-dossier-meta-description'),
      })
    },
    watch: {
      companySlug(slug) {
        if (this.loadedSlug === slug) return
        this.load()
        this.setMetaRobots()
      },
      countryId() {
        this.load()
      },
    }
  }
</script>

<style>

</style>
